import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { albums as initialAlbums } from "../../assets/data/albums";

const AlbumList = () => {
  const navigate = useNavigate();
  const [albumList, setAlbumList] = useState([]);

  // Load albums from initial data or local storage
  useEffect(() => {
    const storedAlbums = JSON.parse(localStorage.getItem("albums")) || [];
    setAlbumList([...initialAlbums, ...storedAlbums]);
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      {/* Center the title */}
      <h1
        style={{
          textAlign: "center",
          margin: "20px 0",
          fontSize: "2.5rem",
          textDecoration: "underline",
          color: "brown",
        }}
      >
        Photo Gallery
      </h1>

      {/* Add Album Button */}
      <button
        onClick={() => navigate("/login/albums/create")}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          background: "#1890ff",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "30px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
        }}
      >
        +
      </button>

      {/* Album Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px",
          padding: "0 20px",
        }}
      >
        {albumList?.map((album) => (
          <div
            key={album.id}
            style={{
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "10px",
              padding: "10px",
              transition: "transform 0.3s",
            }}
          >
            <Link
              to={`/login/albums/${album.id}`}
              style={{ textDecoration: "none", color: "black" }}
            >
              <img
                src={album.photos[0]}
                alt={album.name}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <h3 style={{ marginTop: "10px" }}>{album.name}</h3>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlbumList;
